module.exports = __webpack_public_path__ + "img/dashboard.5f473314.svg";